import { getAuthAxios } from "@artprov/design-system";
import { errorService } from "../../../common/utils/functions/error.service.js";

export const getEstados = async (signal = null) => {
    try {
        const response = await getAuthAxios("default").get(
            '/estados-email-bancario',
            signal ? { signal } : undefined
        );

        return response.data.estados || [];
    } catch (error) {
        if (error.response?.status === 404) {
            return [];
        }

        // Para otros errores, manejar normalmente
        errorService.handleError(error, {
            userMessage: "No pudimos obtener la lista de estados.",
            origen: "getEstados",
        });
        throw error;
    }
};

export const parseEstados = (estados) => {
    if (!Array.isArray(estados)) return [];

    return estados.map(estado => ({
        value: estado.codigo,                // ID numérico para el backend
        label: estado.descripcion            // Nombre para mostrar en UI
    }));
};
